'use strict';
module.exports = require('./Api.js');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/api/index.js
// module id = 1213
// module chunks = 0